var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-top-wrap"},[_c('ul',{staticClass:"menu-wrap"},_vm._l((_vm.navList),function(item,index){return _c('li',{key:index,staticClass:"menu",class:[_vm.activePath==item.linkRoute?'active':''],on:{"click":function($event){return _vm.changeItem(item)}}},[_vm._v(_vm._s(item.menuName))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }